var _circle, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle16W(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "geometricPrecision",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Check circle icon",
    style: {
      verticalAlign: "middle"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "4.5,8 7,11 11.5,5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle16W);
export default __webpack_public_path__ + "static/media/Check_circle_16w.a0a0e0aef6ddb341812e7920170c1971.svg";
export { ForwardRef as ReactComponent };